import { render, staticRenderFns } from "./shareDialog.vue?vue&type=template&id=08e47cc2&scoped=true&"
import script from "./shareDialog.vue?vue&type=script&lang=js&"
export * from "./shareDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08e47cc2",
  null
  
)

export default component.exports